export default "__VITE_ASSET__BpavVktu__"